import { UploadFormComponent } from './upload-form/upload-form.component';
import { UserInfoService } from 'src/app/Services/Utilities/user-info.service';
import { PidGrantService } from './../../Services/Utilities/pid-grant.service';
import { data } from 'jquery';
import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore } from '@angular/fire/firestore';
import { AngularFireStorage } from '@angular/fire/storage';
import { MatPaginator, MatDialog, PageEvent, Sort, MatDialogConfig } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { DateFormatService } from 'src/app/Services/Utilities/date-format.service';
import { FundsServiceService } from 'src/app/Services/Utilities/funds-service.service';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { SubmitFormComponent } from '../cic/submit-form/submit-form.component';
import { NewApplicationComponent } from '../funds/new-application/new-application.component';
import fontkit from '@pdf-lib/fontkit';
import { PDFDocument, StandardFonts, layoutMultilineText, TextAlignment, rgb, PDFPage } from 'pdf-lib';

@Component({
  selector: 'app-pid-grant',
  templateUrl: './pid-grant.component.html',
  styleUrls: ['./pid-grant.component.css']
})
export class PidGrantComponent implements OnInit {

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    private storageRef: AngularFireStorage,
    media: MediaMatcher,
    private firestore: AngularFirestore,
    public router: Router,
    private dialog: MatDialog,
    private angularFireAuth: AngularFireAuth,
    private dateSrv: DateFormatService,
    private toaster: ToastrService,
    private spinner: NgxSpinnerService,
    public doubleTaxSrv: PidGrantService,
    public userSrv: UserInfoService
  ) {
  }

  ngOnInit() {
  }
 
}
